"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const date_fns_1 = __importDefault(require("@date-io/date-fns"));
const pickers_1 = require("@material-ui/pickers");
const styles_1 = require("@material-ui/core/styles");
const core_1 = require("@material-ui/core");
const date_fns_tz_1 = require("date-fns-tz");
const date_fns_2 = require("date-fns");
const formik_1 = require("formik");
const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
class CustomUtils extends date_fns_1.default {
    date(value) {
        const theDate = super.date(value);
        if (theDate) {
            const UTCTime = (0, date_fns_tz_1.zonedTimeToUtc)(theDate, userTimezone);
            return UTCTime;
        }
    }
}
const useStyles = (0, styles_1.makeStyles)((theme) => ({
    root: {
        '& svg': {
            fill: theme.palette.primary.main,
        },
    },
}));
const RenderDateField = (props) => {
    const { field: { value, name }, form: { touched, errors, setFieldValue, setFieldTouched }, fieldLabel, placeholder, minDate, maxDate, minDateMessage, maxDateMessage, onValueChange = () => undefined, ...otherProps } = props;
    const classes = useStyles();
    const error = (0, formik_1.getIn)(errors, name);
    const touch = (0, formik_1.getIn)(touched, name);
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(core_1.Box, { marginBottom: "5px" },
            react_1.default.createElement(core_1.InputLabel, null, fieldLabel)),
        react_1.default.createElement(pickers_1.MuiPickersUtilsProvider, { utils: CustomUtils },
            react_1.default.createElement(pickers_1.KeyboardDatePicker, { name: name, format: "MMMM d, u", InputAdornmentProps: {
                    id: `mui-component-calendar-${name}`,
                    classes: { root: classes.root },
                }, value: value || null, onChange: (value) => {
                    setFieldValue(name, value);
                    onValueChange(value);
                }, onBlur: () => setFieldTouched(name, true), invalidDateMessage: null, error: touch && !!error, autoOk: true, placeholder: placeholder, variant: "inline", inputVariant: "filled", fullWidth: true, disableToolbar: true, disablePast: true, minDate: minDate || undefined, maxDate: maxDate || undefined, minDateMessage: true, maxDateMessage: true, mask: "__/__/____", allowKeyboardControl: false, ...otherProps })),
        touch && !!error && (react_1.default.createElement(core_1.Typography, { variant: "body2", component: "p", color: "error", ...otherProps }, error))));
};
RenderDateField.defaultProps = {
    minDate: (0, date_fns_2.format)(new Date(), 'MMMM d, u'),
    minDateMessage: '',
    maxDateMessage: '',
};
RenderDateField.propTypes = {
    field: prop_types_1.default.any.isRequired,
    form: prop_types_1.default.any.isRequired,
    fieldLabel: prop_types_1.default.string.isRequired,
    placeholder: prop_types_1.default.string,
    onValueChange: prop_types_1.default.func,
};
exports.default = RenderDateField;
